import React, { Children } from 'react';
import classNames from 'classnames';
import { Box } from '@fiverr-private/theme';
import type { TabProps } from '../types';
import { getStylingProps } from './style';
import * as classes from './style.ve.css';
import { renderTabChild } from './helpers';

const Tab = ({
  isLink = false,
  isSelected = false,
  isDisabled = false,
  isStretched = false,
  variant = 'default',
  placement = 'top',
  id,
  panelId,
  onClick,
  children,
  renderChildren = renderTabChild,
  className,
  ...props
}: TabProps) => (
  <Box
    as="button"
    role="tab"
    id={id}
    aria-selected={isSelected ? 'true' : 'false'}
    aria-controls={panelId}
    aria-disabled={isDisabled ? undefined : 'false'}
    disabled={isDisabled}
    tabIndex={isSelected ? 0 : -1}
    data-link={isLink ? 'true' : undefined}
    onClick={onClick}
    className={classNames(
      classes.base,
      {
        [classes.defaultClass]: variant === 'default',
        [classes.isLink]: isLink,
        [classes.left]: placement === 'left',
        [classes.right]: placement === 'right',
        [classes.top]: placement === 'top',
        [classes.bottom]: placement === 'bottom',
      },
      className
    )}
    {...getStylingProps(variant, placement, isLink, isDisabled, isStretched)}
    {...props}
  >
    {Children.map(Children.toArray(children), renderChildren({ isLink }))}
  </Box>
);

Tab.displayName = 'Tab';
Tab.id = 'Tab';

export default Tab;
